
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {readMenuForm} from '@/store/main/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import {
  EnumLogicalOperator,
  EnumQueryBuilderType,
  EnumQueryOperators,
  EnumReturnMode,
  IQueryBuilder,
} from '@/interfaces/query-builder';
import {commitAddNotification, commitSetQueryBuilder} from '@/store/main/mutations';

@Component({
  components: {DefaultHelp},
})
export default class QueryBuilder extends Vue {
  @Prop(Number) public formId;
  @Prop(Function) public searchFunction;
  @Prop(Function) public downloadFunction;

  private selectedField: any = null;
  private search: any = null;
  private enumOp: any = EnumQueryOperators;
  private enumReturnMode: any = EnumReturnMode;
  private queryBuilder: any = {} as IQueryBuilder;

  @Watch('$route')
  public watchRoute() {
    this.loadMountedSettings();
  }

  @Watch('queryBuilder', { immediate: true, deep: true })
  public watchQueryBuilder() {
    // console.log("OK!!");
    // commitSetQueryBuilder(this.$store, this.queryBuilder);
  }

  public async mounted() {
    this.loadMountedSettings();
  }

  private get isDisabled() {
    if (this.queryBuilder?.children) {
      return !this.queryBuilder?.children[0]?.query.operand;
    }
    return false;
  }

  public loadMountedSettings() {
    this.queryBuilder = {
      return_mode: EnumReturnMode.RM_ALL,
      type: EnumQueryBuilderType.QUERY_BUILDER_FILTER,
      children: [
        {
          logical_operator: null,
          query: {
            query_value: null,
            operator: this.enumOp.OP_EQUAL,
            operand: {
              name: null,
              label: null,
            },
          },
        },
      ],
    } as IQueryBuilder;
  }

  private get operators() {
    return [
      {name: 'Igual', value: EnumQueryOperators.OP_EQUAL},
      {name: 'Diferente de', value: EnumQueryOperators.OP_NOT_EQUAL},
      {name: 'Contém', value: EnumQueryOperators.OP_CONTAINS},
      {name: 'Não Contém', value: EnumQueryOperators.OP_NOT_CONTAINS},
      {name: 'Está Entre', value: EnumQueryOperators.OP_IN},
      {name: 'Não Está Entre', value: EnumQueryOperators.OP_NOT_IN},
    ];
  }

  private get operatorsNumerics() {
    return [
      {name: 'Igual', value: EnumQueryOperators.OP_EQUAL},
      {name: 'Diferente de', value: EnumQueryOperators.OP_NOT_EQUAL},
      {name: 'Contém', value: EnumQueryOperators.OP_CONTAINS},
      {name: 'Não Contém', value: EnumQueryOperators.OP_NOT_CONTAINS},
      // {name: 'Está Entre', value: EnumQueryOperators.OP_BETWEEN},
      // {name: 'Não Está Entre', value: EnumQueryOperators.OP_NOT_BETWEEN},
      {name: 'Maior que', value: EnumQueryOperators.OP_GREATER},
      {name: 'Menor que', value: EnumQueryOperators.OP_LESSER},
      {name: 'Maior ou igual que', value: EnumQueryOperators.OP_GREATER_EQUAL},
      {name: 'Menor ou igual que', value: EnumQueryOperators.OP_LESSER_EQUAL},
    ];
  }


  private get conditionals() {
    return [
      {name: 'E', value: EnumLogicalOperator.OP_AND},
      {name: 'OU', value: EnumLogicalOperator.OP_OR},
    ];
  }

  /* tslint:enable */

  private get formData() {
    const data = readMenuForm(this.$store)(+this.formId)?.form_setting?.form_data?.controls;
    if (data) {
      return Object.values(data).map((e: any) => {
        const name = e?.name ? e?.name : e?.uniqueId;
        return {uniqueId: e?.uniqueId, name: name, label: e?.label, type: e?.type};
      });
    }
    return null;
  }

  private executeSearch() {
    // Converte para perder a referência do objeto atual
    const query = JSON.parse(JSON.stringify(this.queryBuilder));

    query.children.forEach(queryItem => {
      try {
        this.validateSearch(queryItem);
      } catch (e) {
        console.error(e)
        return;
      }
    });
    this.searchFunction(query);
  }

  private validateSearch(item: any) {
    const fieldType = item.query.operand.type;
    if (!['datePickerControl', 'datetime'].includes(fieldType)) {
      return;
    }
    const isValidDate = item.query.query_value.length === 10 && item.query.query_value.includes('/')

    if (!isValidDate) {
      commitAddNotification(
          this.$store,
          {content: 'Busca por data deve ser no formato DD/MM/AAAA', color: 'warning'}
      );
      throw new Error('Busca por data deve ser no formato DD/MM/AAAA');
    } else {
      // item.query.query_value = item.query.query_value.split('/').reverse().join('-');
    }


  }


  private addQueryItem() {
    this.queryBuilder.children.push({
      logical_operator: EnumLogicalOperator.OP_AND,
      query_value: null,
      query: {
        operator: EnumQueryOperators.OP_EQUAL,
        operand: {
          op_name: null,
          op_label: null,
        },
      },
    } as unknown as IQueryBuilder);
  }

  private removeQueryItem(index) {
    this.queryBuilder.children.splice(index, 1);
  }

  private getFieldType(item) {
    return item?.type;
  }

}
